import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import './PageList.css';

const PageList = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPages = async () => {
      try {
        setLoading(true);
        const baseUrl = process.env.REACT_APP_API_URL || 'https://hdmovietoday.xyz';
        const response = await axios.get(`${baseUrl}/api/page-templates/published`);
        
        if (response.data.success) {
          setPages(response.data.data);
        } else {
          setError('Failed to load pages');
        }
      } catch (error) {
        console.error('Error fetching pages:', error);
        setError('Error loading pages');
      } finally {
        setLoading(false);
      }
    };

    fetchPages();
  }, []);

  const getPageTypeIcon = (pageType) => {
    switch (pageType) {
      case 'thank-you':
        return '✓';
      case 'landing':
        return '🚀';
      case 'about':
        return 'ℹ️';
      case 'privacy':
        return '🔒';
      case 'terms':
        return '📋';
      default:
        return '📄';
    }
  };

  const getPageTypeLabel = (pageType) => {
    switch (pageType) {
      case 'thank-you':
        return 'Thank You';
      case 'landing':
        return 'Landing Page';
      case 'about':
        return 'About';
      case 'privacy':
        return 'Privacy Policy';
      case 'terms':
        return 'Terms & Conditions';
      default:
        return 'Custom Page';
    }
  };

  if (loading) {
    return (
      <div className="page-list-loading">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading pages...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-list-error">
        <div className="error-container">
          <h2>Unable to Load Pages</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>All Pages - Your Site</title>
        <meta name="description" content="Browse all available pages on our website" />
      </Helmet>
      
      <div className="page-list-container">
        <div className="page-list-header">
          <h1>All Pages</h1>
          <p>Browse all available pages on our website</p>
        </div>
        
        {pages.length === 0 ? (
          <div className="no-pages">
            <h3>No pages available</h3>
            <p>There are currently no published pages available.</p>
          </div>
        ) : (
          <div className="page-grid">
            {pages.map((page) => (
              <div key={page._id} className="page-card">
                <div className="page-icon">
                  {getPageTypeIcon(page.pageType)}
                </div>
                <div className="page-content">
                  <h3 className="page-title">{page.name}</h3>
                  <p className="page-type">{getPageTypeLabel(page.pageType)}</p>
                  {page.seoDescription && (
                    <p className="page-description">{page.seoDescription}</p>
                  )}
                  <div className="page-meta">
                    <span className="page-date">
                      {new Date(page.createdAt).toLocaleDateString()}
                    </span>
                  </div>
                </div>
                <div className="page-actions">
                  <Link 
                    to={`/${page.slug}`} 
                    className="view-page-btn"
                  >
                    View Page
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default PageList;
